import { render } from "./SourcePopover.vue?vue&type=template&id=48c6e406"
import script from "./SourcePopover.vue?vue&type=script&lang=js"
export * from "./SourcePopover.vue?vue&type=script&lang=js"

import "./SourcePopover.vue?vue&type=style&index=0&id=48c6e406&lang=scss"
script.render = render

export default script